// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Onglet Offre PRESTATAIRE-BC (V2). Ne porte QUE les classes presta sans equivalent
   acheteur (bandeaux de statut/instructions/inline, panier inverse). Le rendu des tables
   d'articles, totaux, sections et accordeons vient des feuilles generiques partagees
   (ConsultationBC.css importe ici + globals) + du scope .scbc de SuiviDeCommandeBCV2.css,
   pour une parite VISUELLE exacte avec la case acheteur operation-bc.
   Palette fermee du design system : headers #595959, orange #f97316, texte #374151. */

/* Encart expiration / annulation */
.cmd-offre__expired-notice {
  background-color: #fee;
  border: 2px solid #c33;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 8px;
  color: #c33;
  font-weight: bold;
  text-align: center;
}

/* Bandeau de statut final (✓ / ✗ / ⏰ / ⏳). Espace sous le bandeau : le .scbc__tab-content
   donne deja ~2rem au-dessus, on equilibre avec 2rem en dessous pour qu'il flotte entre la
   barre d'onglets et la premiere section (au lieu d'etre colle au titre de la section). */
.cmd-offre__status {
  border-radius: 8px;
  padding: 1rem 1.25rem;
  font-weight: 600;
  font-size: 1.4rem;
  margin-bottom: 2rem;
}

.cmd-offre__status--accepted {
  background-color: #ecfdf5;
  color: #047857;
  border: 1px solid #6ee7b7;
}

.cmd-offre__status--refused {
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

.cmd-offre__status--expired {
  background-color: #fff7ed;
  color: #c2410c;
  border: 1px solid #fdba74;
}

.cmd-offre__status--waiting {
  background-color: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #93c5fd;
}

/* Bandeau d'instructions panier inverse */
.cmd-offre__instructions {
  background-color: #eff6ff;
  border-left: 4px solid #2196f3;
  border-radius: 4px;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
}

.cmd-offre__instructions h4 {
  margin: 0 0 0.35rem 0;
  color: #595959;
  font-size: 1.5rem;
}

.cmd-offre__instructions p {
  margin: 0;
  color: #374151;
  font-size: 1.3rem;
}

/* Message info "offre envoyee" (AttenteAnalyse) */
.cmd-offre__info {
  margin-bottom: 1.25rem;
  padding: 0.9rem 1.1rem;
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
  border-radius: 4px;
  color: #1976d2;
  font-weight: 500;
  font-size: 1.3rem;
}

/* Bouton d'envoi / choix initial du chiffrage (panier inverse) */
.cmd-offre__chiffrage-send,
.cmd-offre__choice {
  display: flex;
  justify-content: center;
  margin-top: 1.25rem;
}

/* Message inline (remplace alert) */
.cmd-offre__inline-message {
  border-radius: 6px;
  padding: 0.75rem 1rem;
  font-size: 1.3rem;
}

.cmd-offre__inline-message--error {
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

/* Rangee d'actions */
.cmd-offre__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviDeCommandeBCV2/components/CommandeOffre.css"],"names":[],"mappings":"AAAA;;;;;sFAKsF;;AAEtF,mCAAmC;AACnC;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;0FAE0F;AAC1F;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["/* Onglet Offre PRESTATAIRE-BC (V2). Ne porte QUE les classes presta sans equivalent\n   acheteur (bandeaux de statut/instructions/inline, panier inverse). Le rendu des tables\n   d'articles, totaux, sections et accordeons vient des feuilles generiques partagees\n   (ConsultationBC.css importe ici + globals) + du scope .scbc de SuiviDeCommandeBCV2.css,\n   pour une parite VISUELLE exacte avec la case acheteur operation-bc.\n   Palette fermee du design system : headers #595959, orange #f97316, texte #374151. */\n\n/* Encart expiration / annulation */\n.cmd-offre__expired-notice {\n  background-color: #fee;\n  border: 2px solid #c33;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 8px;\n  color: #c33;\n  font-weight: bold;\n  text-align: center;\n}\n\n/* Bandeau de statut final (✓ / ✗ / ⏰ / ⏳). Espace sous le bandeau : le .scbc__tab-content\n   donne deja ~2rem au-dessus, on equilibre avec 2rem en dessous pour qu'il flotte entre la\n   barre d'onglets et la premiere section (au lieu d'etre colle au titre de la section). */\n.cmd-offre__status {\n  border-radius: 8px;\n  padding: 1rem 1.25rem;\n  font-weight: 600;\n  font-size: 1.4rem;\n  margin-bottom: 2rem;\n}\n\n.cmd-offre__status--accepted {\n  background-color: #ecfdf5;\n  color: #047857;\n  border: 1px solid #6ee7b7;\n}\n\n.cmd-offre__status--refused {\n  background-color: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fca5a5;\n}\n\n.cmd-offre__status--expired {\n  background-color: #fff7ed;\n  color: #c2410c;\n  border: 1px solid #fdba74;\n}\n\n.cmd-offre__status--waiting {\n  background-color: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #93c5fd;\n}\n\n/* Bandeau d'instructions panier inverse */\n.cmd-offre__instructions {\n  background-color: #eff6ff;\n  border-left: 4px solid #2196f3;\n  border-radius: 4px;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.cmd-offre__instructions h4 {\n  margin: 0 0 0.35rem 0;\n  color: #595959;\n  font-size: 1.5rem;\n}\n\n.cmd-offre__instructions p {\n  margin: 0;\n  color: #374151;\n  font-size: 1.3rem;\n}\n\n/* Message info \"offre envoyee\" (AttenteAnalyse) */\n.cmd-offre__info {\n  margin-bottom: 1.25rem;\n  padding: 0.9rem 1.1rem;\n  background-color: #e3f2fd;\n  border-left: 4px solid #2196f3;\n  border-radius: 4px;\n  color: #1976d2;\n  font-weight: 500;\n  font-size: 1.3rem;\n}\n\n/* Bouton d'envoi / choix initial du chiffrage (panier inverse) */\n.cmd-offre__chiffrage-send,\n.cmd-offre__choice {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.25rem;\n}\n\n/* Message inline (remplace alert) */\n.cmd-offre__inline-message {\n  border-radius: 6px;\n  padding: 0.75rem 1rem;\n  font-size: 1.3rem;\n}\n\n.cmd-offre__inline-message--error {\n  background-color: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fca5a5;\n}\n\n/* Rangee d'actions */\n.cmd-offre__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
